import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () => {
  return axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })
}

const bangkokbankApi = {
  getBangkokbankJobInterests: (request) => {
    return instance().get(`/api/bangkokbank/job-interest-get-list`, { params: request })
  },
  getBangkokbankJobInterestsbyId: (request) => {
    return instance().get(`/api/bangkokbank/job-interest-get-by-id`, { params: request })
  },
  createBangkokbankJobInterests: (data) => {
    return instance().post(`/api/bangkokbank/job-interest-create`, data)
  },
  putEditBangkokbankJobInterests: (data) => {
    return instance().put(`/api/bangkokbank/job-interest-update`, data)
  },
  updateBangkokbankJobInterestIsActive: (data) => {
    return instance().put(`/api/bangkokbank/job-interest-update-is-active`, data)
  },
  deleteBangkokbankJobInterests: (id, pageId) => {
    return instance().delete(`/api/bangkokbank/job-interest-delete/${id}`, {
      data: {
        page_id: pageId
      }
    })
  },
  updateSortBangkokbankJobInterests: (data) => {
    return instance().put(`/api/bangkokbank/job-sort-update`, data)
  }
}

export default bangkokbankApi



// WEBPACK FOOTER //
// ./src/api/bangkokbank.js